<router-outlet></router-outlet>
<ui-persistent-notification [message]="'reload_orchestrator_after_upgrade_message' | translate"
                            [buttonLabel]="'ui_persistent_refresh' | translate">
</ui-persistent-notification>
